module.exports = __webpack_public_path__ + "static/img/wave_bottom.png";